import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ReservationPage = lazy(() => import('../pages/reservation/page'));
const TransfersPage = lazy(() => import('../pages/transfers/page'));
const AllTransfersPage = lazy(() => import('../pages/all-transfers/page'));
const StationsPage = lazy(() => import('../pages/stations/page'));
const LechereTransfersPage = lazy(() => import('../pages/lechere-transfers/page'));
const ChamberyAirportPage = lazy(() => import('../pages/chambery-airport/page'));
const LyonAirportPage = lazy(() => import('../pages/lyon-airport/page'));
const GrenobleAirportPage = lazy(() => import('../pages/grenoble-airport/page'));
const GenevaAirportPage = lazy(() => import('../pages/geneva-airport/page'));
const MarseilleAirportPage = lazy(() => import('../pages/marseille-airport/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const LegalPage = lazy(() => import('../pages/legal/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ToulonAirportPage = lazy(() => import('../pages/toulon-airport/page'));
const GalleryPage = lazy(() => import('../pages/gallery/page'));
const AccountPage = lazy(() => import('../pages/account/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/reservation',
    element: <ReservationPage />,
  },
  {
    path: '/transferts',
    element: <AllTransfersPage />,
  },
  {
    path: '/stations',
    element: <StationsPage />,
  },
  {
    path: '/transfers',
    element: <TransfersPage />,
  },
  {
    path: '/transfert-la-lechere',
    element: <LechereTransfersPage />,
  },
  {
    path: '/transfert-aeroport-chambery',
    element: <ChamberyAirportPage />,
  },
  {
    path: '/chambery-airport',
    element: <ChamberyAirportPage />,
  },
  {
    path: '/transfert-aeroport-lyon',
    element: <LyonAirportPage />,
  },
  {
    path: '/lyon-airport',
    element: <LyonAirportPage />,
  },
  {
    path: '/transfert-aeroport-grenoble',
    element: <GrenobleAirportPage />,
  },
  {
    path: '/grenoble-airport',
    element: <GrenobleAirportPage />,
  },
  {
    path: '/transfert-aeroport-geneve',
    element: <GenevaAirportPage />,
  },
  {
    path: '/geneva-airport',
    element: <GenevaAirportPage />,
  },
  {
    path: '/transfert-aeroport-marseille',
    element: <MarseilleAirportPage />,
  },
  {
    path: '/marseille-airport',
    element: <MarseilleAirportPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/tarifs',
    element: <PricingPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/legal',
    element: <LegalPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/toulon-airport',
    element: <ToulonAirportPage />,
  },
  {
    path: '/galerie',
    element: <GalleryPage />,
  },
  {
    path: '/mon-compte',
    element: <AccountPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
